import React, { useState } from 'react';
import classNames from 'classnames';
import { useChallengeStatus } from '../../model/hooks/useChallengeStatus';
import ChallengeSectionInfo from './ChallengeSectionInfo';
import ChallengeSectionReward from './ChallengeSectionReward';
import ChallengeSectionBody from './ChallengeSectionBody';
import { AVAILABLE, COLLECTED, COMPLETED } from '../../../../../constants/components/pages/challenges/statuses';

const ChallengeSection = React.forwardRef(function ({ challengeData, isNy = false }, ref) {
  const [isVisibleBody, setIsVisibleBody] = useState(false);
  const status = useChallengeStatus(challengeData);

  return (
    <div
      ref={ref}
      className={classNames('challenges__section', {
        challenges__section_active: status === AVAILABLE && isVisibleBody,
        challenges__section_done: [COLLECTED, COMPLETED].includes(status),
        challenges__section_burgundy: challengeData?.isSpecial,
      })}
      onClick={() => setIsVisibleBody((prev) => !prev)}
    >
      <div className={'challenges__section-header'}>
        <ChallengeSectionReward challengeData={challengeData} />
        <ChallengeSectionInfo status={status} challengeData={challengeData} />
      </div>

      <ChallengeSectionBody status={status} challengeData={challengeData} isVisibleBody={isVisibleBody} />
    </div>
  );
});
export default ChallengeSection;
ChallengeSection.propTypes = {};
